module.exports = __webpack_public_path__ + "img/works_active.6617c394.png";